import { connect } from 'react-redux'
import FittingOrdererUploadComponent from '../components/FittingOrdererUploadComponent.jsx';
import {
  uploadOrdererData,
  uploadFittingData,
  clearFittingOrdererAlert,
  deleteFittingRecordByDuration
} from '../actions';

const mapStateToProps = (state) => ({
  orderId: state.getIn(['fittingReducer', 'orderId']),
  alertStyle: state.getIn(['fittingReducer', 'alertStyle']),
  alertMessage: state.getIn(['fittingReducer', 'alertMessage']),
  showForceUpload: state.getIn(['fittingReducer', 'showForceUpload']),
})

const mapDispatchToProps = (dispatch) => ({
  uploadOrderer: (payload, uploadOrdererFile) => {
    dispatch(uploadOrdererData(payload, uploadOrdererFile));
  },
  uploadFitting: (payload, uploadFittingFile, forceUpload) => {
    dispatch(uploadFittingData(payload, uploadFittingFile, forceUpload));
  },
  clearOrdererAlert: () => {
    dispatch(clearFittingOrdererAlert());
  },
  deleteFittingRecordByDuration: (payload) => {
    dispatch(deleteFittingRecordByDuration(payload));
  },
})

const FittingOrdererUploadContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FittingOrdererUploadComponent)

export default FittingOrdererUploadContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingOrdererUploadContainer.jsx